import React, { useState } from "react";
import { Check, Plus, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

import SeletorNatureza from "../components/SeletorNatureza";

// Classificação da despesa + "Criar nova classificação" sem sair da tela.
// A natureza é obrigatória: é ela que decide a linha do DRE.
export default function CampoClassificacao({ valor, onChange, classificacoes, aoCriar }) {
  const [criando, setCriando] = useState(false);
  const [nome, setNome] = useState("");
  const [natureza, setNatureza] = useState("");
  const confirmar = async () => {
    if (await aoCriar(nome, natureza)) { setCriando(false); setNome(""); setNatureza(""); }
  };
  return (
    <div>
      <Select value={valor || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
        <SelectTrigger data-e2e="campo-classificacao"><SelectValue placeholder="Selecione uma classificação" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Sem classificação</SelectItem>
          {classificacoes.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {!criando ? (
        <Button type="button" variant="link" size="sm" className="p-0 h-auto text-xs mt-1" onClick={() => setCriando(true)}>
          <Plus className="w-3 h-3 mr-1" />Criar nova classificação
        </Button>
      ) : (
        <div className="flex flex-wrap gap-2 mt-2">
          <SeletorNatureza valor={natureza} onChange={setNatureza} compacto />
          <Input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome da nova classificação" className="h-8 text-sm flex-1 min-w-[160px]"
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); confirmar(); } }} />
          <Button type="button" size="sm" className="h-8 px-2" onClick={confirmar}><Check className="w-4 h-4" /></Button>
          <Button type="button" variant="ghost" size="sm" className="h-8 px-2" onClick={() => { setCriando(false); setNome(""); }}><X className="w-4 h-4" /></Button>
        </div>
      )}
    </div>
  );
}
